import React, { Component } from "react";

export class Download extends Component {
  render() {
    return (
      <div>
        <h1>Download Page</h1>
      </div>
    );
  }
}

export default Download;
